/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSectionRouteImport } from './routes/_app/$section'
import { Route as AppApprovalsRouteImport } from './routes/_app/approvals'
import { Route as AppLibraryRouteImport } from './routes/_app/library'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSurveysRouteImport } from './routes/_app/surveys'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as PreviewIdRouteImport } from './routes/preview.$id'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AppContractsIndexRouteImport } from './routes/_app/contracts/index'
import { Route as AppContractsIdRouteImport } from './routes/_app/contracts/$id'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers/$id'
import { Route as AppEnquiriesIndexRouteImport } from './routes/_app/enquiries/index'
import { Route as AppEnquiriesIdRouteImport } from './routes/_app/enquiries/$id'
import { Route as AppOnboardingIndexRouteImport } from './routes/_app/onboarding/index'
import { Route as AppOnboardingIdRouteImport } from './routes/_app/onboarding/$id'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppQuotesIdRouteImport } from './routes/_app/quotes/$id'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsSlugRouteImport } from './routes/_app/settings/$slug'
import { Route as ContractsIdPrintRouteImport } from './routes/contracts.$id.print'
import { Route as AppQuotesIdSurveyRouteImport } from './routes/_app/quotes/$id_.survey'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSectionRoute = AppSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryRoute = AppLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSurveysRoute = AppSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => AppRoute,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewIdRoute = PreviewIdRouteImport.update({
  id: '/preview/$id',
  path: '/preview/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppContractsIndexRoute = AppContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsIdRoute = AppContractsIdRouteImport.update({
  id: '/contracts/$id',
  path: '/contracts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppEnquiriesIndexRoute = AppEnquiriesIndexRouteImport.update({
  id: '/enquiries/',
  path: '/enquiries/',
  getParentRoute: () => AppRoute,
} as any)
const AppEnquiriesIdRoute = AppEnquiriesIdRouteImport.update({
  id: '/enquiries/$id',
  path: '/enquiries/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingIndexRoute = AppOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingIdRoute = AppOnboardingIdRouteImport.update({
  id: '/onboarding/$id',
  path: '/onboarding/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIdRoute = AppQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSlugRoute = AppSettingsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AppSettingsRoute,
} as any)
const ContractsIdPrintRoute = ContractsIdPrintRouteImport.update({
  id: '/contracts/$id/print',
  path: '/contracts/$id/print',
  getParentRoute: () => rootRouteImport,
} as any)
const AppQuotesIdSurveyRoute = AppQuotesIdSurveyRouteImport.update({
  id: '/quotes/$id_/survey',
  path: '/quotes/$id/survey',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/$section': typeof AppSectionRoute
  '/approvals': typeof AppApprovalsRoute
  '/library': typeof AppLibraryRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/surveys': typeof AppSurveysRoute
  '/p/$token': typeof PTokenRoute
  '/preview/$id': typeof PreviewIdRoute
  '/s/$token': typeof STokenRoute
  '/contracts/$id': typeof AppContractsIdRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/enquiries/$id': typeof AppEnquiriesIdRoute
  '/onboarding/$id': typeof AppOnboardingIdRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/settings/$slug': typeof AppSettingsSlugRoute
  '/contracts/$id/print': typeof ContractsIdPrintRoute
  '/contracts/': typeof AppContractsIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/enquiries/': typeof AppEnquiriesIndexRoute
  '/onboarding/': typeof AppOnboardingIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/quotes/$id/survey': typeof AppQuotesIdSurveyRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/$section': typeof AppSectionRoute
  '/approvals': typeof AppApprovalsRoute
  '/library': typeof AppLibraryRoute
  '/surveys': typeof AppSurveysRoute
  '/p/$token': typeof PTokenRoute
  '/preview/$id': typeof PreviewIdRoute
  '/s/$token': typeof STokenRoute
  '/': typeof AppIndexRoute
  '/contracts/$id': typeof AppContractsIdRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/enquiries/$id': typeof AppEnquiriesIdRoute
  '/onboarding/$id': typeof AppOnboardingIdRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/settings/$slug': typeof AppSettingsSlugRoute
  '/contracts/$id/print': typeof ContractsIdPrintRoute
  '/contracts': typeof AppContractsIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/enquiries': typeof AppEnquiriesIndexRoute
  '/onboarding': typeof AppOnboardingIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/quotes/$id/survey': typeof AppQuotesIdSurveyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/$section': typeof AppSectionRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/library': typeof AppLibraryRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/surveys': typeof AppSurveysRoute
  '/p/$token': typeof PTokenRoute
  '/preview/$id': typeof PreviewIdRoute
  '/s/$token': typeof STokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/contracts/$id': typeof AppContractsIdRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/enquiries/$id': typeof AppEnquiriesIdRoute
  '/_app/onboarding/$id': typeof AppOnboardingIdRoute
  '/_app/quotes/$id': typeof AppQuotesIdRoute
  '/_app/settings/$slug': typeof AppSettingsSlugRoute
  '/contracts/$id/print': typeof ContractsIdPrintRoute
  '/_app/contracts/': typeof AppContractsIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/enquiries/': typeof AppEnquiriesIndexRoute
  '/_app/onboarding/': typeof AppOnboardingIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/quotes/$id_/survey': typeof AppQuotesIdSurveyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/$section'
    | '/approvals'
    | '/library'
    | '/settings'
    | '/surveys'
    | '/p/$token'
    | '/preview/$id'
    | '/s/$token'
    | '/contracts/$id'
    | '/customers/$id'
    | '/enquiries/$id'
    | '/onboarding/$id'
    | '/quotes/$id'
    | '/settings/$slug'
    | '/contracts/$id/print'
    | '/contracts/'
    | '/customers/'
    | '/enquiries/'
    | '/onboarding/'
    | '/quotes/'
    | '/settings/'
    | '/quotes/$id/survey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/$section'
    | '/approvals'
    | '/library'
    | '/surveys'
    | '/p/$token'
    | '/preview/$id'
    | '/s/$token'
    | '/'
    | '/contracts/$id'
    | '/customers/$id'
    | '/enquiries/$id'
    | '/onboarding/$id'
    | '/quotes/$id'
    | '/settings/$slug'
    | '/contracts/$id/print'
    | '/contracts'
    | '/customers'
    | '/enquiries'
    | '/onboarding'
    | '/quotes'
    | '/settings'
    | '/quotes/$id/survey'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_app/$section'
    | '/_app/approvals'
    | '/_app/library'
    | '/_app/settings'
    | '/_app/surveys'
    | '/p/$token'
    | '/preview/$id'
    | '/s/$token'
    | '/_app/'
    | '/_app/contracts/$id'
    | '/_app/customers/$id'
    | '/_app/enquiries/$id'
    | '/_app/onboarding/$id'
    | '/_app/quotes/$id'
    | '/_app/settings/$slug'
    | '/contracts/$id/print'
    | '/_app/contracts/'
    | '/_app/customers/'
    | '/_app/enquiries/'
    | '/_app/onboarding/'
    | '/_app/quotes/'
    | '/_app/settings/'
    | '/_app/quotes/$id_/survey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  PTokenRoute: typeof PTokenRoute
  PreviewIdRoute: typeof PreviewIdRoute
  STokenRoute: typeof STokenRoute
  ContractsIdPrintRoute: typeof ContractsIdPrintRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$section': {
      id: '/_app/$section'
      path: '/$section'
      fullPath: '/$section'
      preLoaderRoute: typeof AppSectionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library': {
      id: '/_app/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AppLibraryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/surveys': {
      id: '/_app/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof AppSurveysRouteImport
      parentRoute: typeof AppRoute
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/$id': {
      id: '/preview/$id'
      path: '/preview/$id'
      fullPath: '/preview/$id'
      preLoaderRoute: typeof PreviewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/contracts/': {
      id: '/_app/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AppContractsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contracts/$id': {
      id: '/_app/contracts/$id'
      path: '/contracts/$id'
      fullPath: '/contracts/$id'
      preLoaderRoute: typeof AppContractsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/enquiries/': {
      id: '/_app/enquiries/'
      path: '/enquiries'
      fullPath: '/enquiries/'
      preLoaderRoute: typeof AppEnquiriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/enquiries/$id': {
      id: '/_app/enquiries/$id'
      path: '/enquiries/$id'
      fullPath: '/enquiries/$id'
      preLoaderRoute: typeof AppEnquiriesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/': {
      id: '/_app/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AppOnboardingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/$id': {
      id: '/_app/onboarding/$id'
      path: '/onboarding/$id'
      fullPath: '/onboarding/$id'
      preLoaderRoute: typeof AppOnboardingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$id': {
      id: '/_app/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/$slug': {
      id: '/_app/settings/$slug'
      path: '/$slug'
      fullPath: '/settings/$slug'
      preLoaderRoute: typeof AppSettingsSlugRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/contracts/$id/print': {
      id: '/contracts/$id/print'
      path: '/contracts/$id/print'
      fullPath: '/contracts/$id/print'
      preLoaderRoute: typeof ContractsIdPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/quotes/$id_/survey': {
      id: '/_app/quotes/$id_/survey'
      path: '/quotes/$id/survey'
      fullPath: '/quotes/$id/survey'
      preLoaderRoute: typeof AppQuotesIdSurveyRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsSlugRoute: typeof AppSettingsSlugRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsSlugRoute: AppSettingsSlugRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppSectionRoute: typeof AppSectionRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppLibraryRoute: typeof AppLibraryRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppSurveysRoute: typeof AppSurveysRoute
  AppIndexRoute: typeof AppIndexRoute
  AppContractsIdRoute: typeof AppContractsIdRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppEnquiriesIdRoute: typeof AppEnquiriesIdRoute
  AppOnboardingIdRoute: typeof AppOnboardingIdRoute
  AppQuotesIdRoute: typeof AppQuotesIdRoute
  AppContractsIndexRoute: typeof AppContractsIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppEnquiriesIndexRoute: typeof AppEnquiriesIndexRoute
  AppOnboardingIndexRoute: typeof AppOnboardingIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppQuotesIdSurveyRoute: typeof AppQuotesIdSurveyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSectionRoute: AppSectionRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppLibraryRoute: AppLibraryRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSurveysRoute: AppSurveysRoute,
  AppIndexRoute: AppIndexRoute,
  AppContractsIdRoute: AppContractsIdRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppEnquiriesIdRoute: AppEnquiriesIdRoute,
  AppOnboardingIdRoute: AppOnboardingIdRoute,
  AppQuotesIdRoute: AppQuotesIdRoute,
  AppContractsIndexRoute: AppContractsIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppEnquiriesIndexRoute: AppEnquiriesIndexRoute,
  AppOnboardingIndexRoute: AppOnboardingIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppQuotesIdSurveyRoute: AppQuotesIdSurveyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  PTokenRoute: PTokenRoute,
  PreviewIdRoute: PreviewIdRoute,
  STokenRoute: STokenRoute,
  ContractsIdPrintRoute: ContractsIdPrintRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
